import {
  fromJS
} from 'immutable';
import {
  handleActions
} from 'redux-actions';
import {
  combineReducers
} from 'redux-immutable';
import * as Types from '../actions/constants';
import personasRecordsReducer from './personasRecordsReducer';
import personasUpsertReducer from './personasUpsertReducer';

const INITIAL_STATE = fromJS({
  upsertModal: false
});

export default combineReducers({
  records: personasRecordsReducer,
  form: personasUpsertReducer,
  visibility: handleActions({
    [Types.TOGGLE_PERSONA_UPSERT_MODAL]: (state, action) => state.set('upsertModal', !state.get('upsertModal'))
  }, INITIAL_STATE)
});



// WEBPACK FOOTER //
// ./client/store/reducers/personasReducer.js